// Mock data for Ukiyo Tours website

export const heroContent = {
  headline: "Curated International Holidays",
  subheading: "Maldives, India, Southeast Asia & Europe — thoughtfully designed for unforgettable travel",
  ctaText: "Plan Your Holiday on WhatsApp",
  whatsappNumber: "918591732501",
  whatsappMessage: "Hi Ukiyo Tours! I'd like to plan my next holiday.",
  heroVideo: "https://cdn.coverr.co/videos/coverr-aerial-view-of-maldives-resort-8339/1080p.mp4"
};

export const trustStrip = [
  "Curated itineraries",
  "Best value pricing",
  "End-to-end support"
];

export const destinations = [
  {
    id: 1,
    title: "Maldives",
    subtitle: "Primary",
    description: "Luxury island escapes with water villas and curated resort stays",
    priceAnchor: "4 Nights packages starting from ₹70,000 per person",
    image: "https://images.unsplash.com/photo-1633503736361-7e6d207abbf7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxtYWxkaXZlcyUyMHdhdGVyJTIwdmlsbGF8ZW58MHx8fHwxNzc2NTA3NTI3fDA&ixlib=rb-4.1.0&q=85",
    icon: "palmtree"
  },
  {
    id: 2,
    title: "India",
    subtitle: "",
    description: "Curated escapes across Himachal, Kashmir, Kerala and more",
    priceAnchor: "Starting from ₹15,000 onwards",
    image: "https://images.unsplash.com/photo-1676718912572-b3ebcff192e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxpbmRpYSUyMGhpbWFsYXlhfGVufDB8fHx8MTc3NjUxNjEwMHww&ixlib=rb-4.1.0&q=85",
    icon: "mountain"
  },
  {
    id: 3,
    title: "Southeast Asia",
    subtitle: "",
    description: "Vietnam, Bali, Thailand and beyond",
    priceAnchor: "Starting from ₹35,000 onwards",
    image: "https://images.unsplash.com/photo-1643030595382-79273ae819d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHx2aWV0bmFtJTIwdHJhdmVsfGVufDB8fHx8MTc3NjUwNzU2Mnww&ixlib=rb-4.1.0&q=85",
    icon: "map"
  },
  {
    id: 4,
    title: "Europe",
    subtitle: "",
    description: "Iconic cities and scenic journeys",
    priceAnchor: "Starting from ₹90,000 onwards",
    image: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxldXJvcGUlMjB0cmF2ZWx8ZW58MHx8fHwxNzc2NTA3NTk4fDA&ixlib=rb-4.1.0&q=85",
    icon: "landmark"
  }
];

export const featuredPackage = {
  title: "Maldives Getaway",
  duration: "4 Nights",
  accommodation: "3N Beach Villa + 1N Water Villa",
  meals: "Full Board",
  transfers: "Speedboat Transfers Included",
  price: "₹70,000",
  priceNote: "per person",
  ctaText: "Check Availability on WhatsApp",
  image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzc2NDA5MTkyfDA&ixlib=rb-4.1.0&q=85"
};

export const whyUkiyo = [
  {
    id: 1,
    title: "Curated, Not Generic",
    description: "Every itinerary is thoughtfully designed — no copy-paste packages.",
    icon: "sparkles"
  },
  {
    id: 2,
    title: "Best-Value Pricing",
    description: "Access to competitive pricing via our global supplier network.",
    icon: "badge-dollar-sign"
  },
  {
    id: 3,
    title: "End-to-End Support",
    description: "Complete planning and on-trip assistance from start to finish.",
    icon: "headset"
  },
  {
    id: 4,
    title: "Transparent & Reliable",
    description: "Clear communication and reliable booking experience.",
    icon: "shield-check"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Share your travel plans",
    description: "Tell us your dates, budget, and preferences."
  },
  {
    step: 2,
    title: "Get curated options",
    description: "We'll present the best choices tailored to your needs."
  },
  {
    step: 3,
    title: "Confirm & relax",
    description: "We handle everything — bookings, vouchers, and support."
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Thoughtfully curated experience with attention to every detail. Highly recommend for stress-free planning.",
    author: "Happy Traveler"
  },
  {
    id: 2,
    text: "Seamless planning and excellent resort recommendations. Made our Maldives trip truly special.",
    author: "Satisfied Customer"
  }
];

export const footerContent = {
  companyName: "Ukiyo Tours",
  tagline: "Curated Travel Experiences",
  destinations: "Maldives • India • Southeast Asia • Europe",
  location: "India",
  email: "hello.ukiyotours@gmail.com",
  venture: "A Crest Softech Venture",
  whatsappNumber: "918591732501"
};
